import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  createProjectExpense(
    data: Boundaries["createProjectExpense"]["request"],
  ): void;
}

function useCreateProjectExpense(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isCreateProjectExpenseRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isCreateProjectExpenseRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isCreateProjectExpenseRequestFailure,
    ),
    createProjectExpense: core.createProjectExpense,
  };
}

export { useCreateProjectExpense };
